import React from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { connect } from "react-redux";
import s from "./Verification.css";
import Link from "../../components/Link";
import QRCode from "react-qr-code";
import cx from "classnames";
import EmailVerificationModal from "../../components/EmailVerificationModal/EmailVerificationModal";
import NumberVerificationModal from "../../components/NumberVerificationModal/NumberVerificationModal";
import { MdContentCopy } from "react-icons/md";
import { FaCheck } from "react-icons/fa6";
import clockIcon from "../../../public/SiteIcons/timerIcon.svg";
import { Modal } from "react-bootstrap";
import SkipVerificationModal from "../../components/SkipVerificationModal/SkipVerificationModal";
import { checkVerificationStatus } from "../../actions/QRCode/checkVerificationStatus";
import VerificationSuccess from "../../components/VerificationSuccess/VerificationSuccess";
import VerificationLoaderModal from "../../components/VerificationLoaderModal/VerificationLoaderModal";
import VerificationFailedModal from "../../components/VerificationFailedModal/VerificationFailedModal";
import CodeVerificationSuccessModal from "../../components/CodeVerificationSuccessModal/CodeVerificationSuccessModal";
// import history from "../../core/history"; // Not used, navigation will use window.location
import { getDocumentVerificationStatus } from "../../actions/DocumentVerification/getDocumentVerificationStatus";
import { FormattedMessage } from "react-intl";
import messages from "../../locale/messages";
// import { toast } from "react-toastify";
import { getDocumentVerifications } from "../../actions/DocumentVerification/getDocumentVerifications";

class Verification extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    generateQRCode: PropTypes.func.isRequired,
    qrCode: PropTypes.string,
    reference: PropTypes.string,
    url: PropTypes.string,
    isLoading: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    errorCode: PropTypes.string,
    status: PropTypes.string,
    checkVerificationStatus: PropTypes.func.isRequired,
    userId: PropTypes.string,
    username: PropTypes.string,
    getDocumentVerificationStatus: PropTypes.func.isRequired,
    getDocumentVerifications: PropTypes.func.isRequired,  
  };

  state = {
    isExpired: false,
    isRefreshing: false,
    timeLeft: 900, // Changed back to 900 seconds (15 minutes) from 60 seconds
    showEmailModal: false,
    showSkipModal: false,
    showNumberModal: false,
    showSuccessModal: false,
    statusCheckInterval: null,
    showLoaderModal: false,
    showFailedModal: false,
    showCodeSuccessModal: false,
    retryAttempted: false,
    copied: false,
  };

  componentDidMount() {
    this.startTimer();
    this.startStatusCheck(); // This will start checking with static reference
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.state.statusCheckInterval) {
      clearInterval(this.state.statusCheckInterval);
    }
  }

  startTimer = () => {
    this.timer = setInterval(() => {
      this.setState((prevState) => {
        const newTimeLeft = prevState.timeLeft - 1;
        if (newTimeLeft <= 0) {
          clearInterval(this.timer);
          return {
            timeLeft: 0,
            isExpired: true,
          };
        }
        return { timeLeft: newTimeLeft };
      });
    }, 1000);
  };

  startStatusCheck = async () => {
    // Only start if we don't already have an interval running
    if (this.state.statusCheckInterval) return;

    // Use userId from props
    const { userId } = this.props;
    
    if (userId) {
      // Initial check immediately
     // this.props.getDocumentVerificationStatus('daefeaf0-3bae-11f0-b145-fb6dedabf48a');
      this.props.getDocumentVerifications(userId);
   
      // Check every 5 seconds for 15 minutes
      const interval = setInterval(async () => {
        try {
        //  const result = await this.props.getDocumentVerificationStatus('daefeaf0-3bae-11f0-b145-fb6dedabf48a');
          const result = await this.props.getDocumentVerifications(userId);

          if (result === "accept") {
            clearInterval(interval);
            this.setState({
              statusCheckInterval: null,
              showSuccessModal: true,
            });
          } else if (result === "reject") {
            clearInterval(interval);
            this.setState({
              statusCheckInterval: null,
              showFailedModal: true,
            });
          }
          // For null result (pending or not_found), continue polling
        } catch (error) {
          console.error("Error checking document verification status:", error);
        }
      }, 5000);

      this.setState({ statusCheckInterval: interval });

      // Stop checking after 15 minutes
      setTimeout(() => {
        if (this.state.statusCheckInterval === interval) {
          clearInterval(interval);
          this.setState({
            statusCheckInterval: null,
          });
        }
      }, 900000);
   }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.reference &&
      !prevProps.reference &&
      !this.state.statusCheckInterval
    ) {
      this.startStatusCheck();
    }
  }

  formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  // QR code is now generated directly in render using userId, no API call needed.
  generateQRCode = () => {};

  refreshQRCode = async () => {
    this.setState({ isRefreshing: true });

    // Clear existing timer
    if (this.timer) {
      clearInterval(this.timer);
    }

    // Clear existing status check interval
    if (this.state.statusCheckInterval) {
      clearInterval(this.state.statusCheckInterval);
      this.setState({ statusCheckInterval: null });
    }

    // Reset state
    this.setState({
      timeLeft: 900,
      isRefreshing: false,
      isExpired: false,
      retryAttempted: false,
    });

    this.startTimer();
    this.startStatusCheck();
  };

  toggleEmailModal = () => {
    this.setState((prevState) => ({
      showEmailModal: !prevState.showEmailModal,
    }));
  };

  toggleSkipModal = () => {
    this.setState((prevState) => ({
      showSkipModal: !prevState.showSkipModal,
    }));
  };

  toggleNumberModal = () => {
    this.setState((prevState) => ({
      showNumberModal: !prevState.showNumberModal,
    }));
  };

  toggleSuccessModal = () => {
    this.setState((prevState) => ({
      showSuccessModal: !prevState.showSuccessModal,
    }));
  };

  toggleLoaderModal = () => {
    this.setState((prevState) => ({
      showLoaderModal: !prevState.showLoaderModal,
    }));
  };

  toggleFailedModal = () => {
    this.setState((prevState) => ({
      showFailedModal: !prevState.showFailedModal,
    }));
  };

  toggleCodeSuccessModal = () => {
    this.setState((prevState) => ({
      showCodeSuccessModal: !prevState.showCodeSuccessModal,
    }));
  };

  handleSuccessClose = () => {
    this.toggleSuccessModal();
    if (typeof window !== "undefined") {
      window.location = "/dashboard"; // Redirect to dashboard
    }
  };

  handleFailedRetry = () => {
    if (!this.state.retryAttempted) {
      // First retry attempt - restart verification check
      this.setState({ retryAttempted: true });
      this.toggleFailedModal();
      this.startStatusCheck();
    } else {
      // Subsequent retries - just close the modal
      this.toggleFailedModal();
    }
  };

  handleCopyLink = () => {
    const { userId } = this.props;
   
    const url =  `https://www.motostream.app/redirect.html?userId=${userId || ""}`; // Prevent SSR crash

    if (!url) {
      console.error("No URL available to copy");
      return;
    }

    try {
      navigator.clipboard.writeText(url).then(() => {
        this.setState({ copied: true });
        setTimeout(() => {
          this.setState({ copied: false });
        }, 2000);
      });
    } catch (err) {
      console.error("Failed to copy link:", err);
    }
  };

  render() {
    const {
      isExpired,
      isRefreshing,
      timeLeft,
      showEmailModal,
      showSkipModal,
      showNumberModal,
    } = this.state;

    const {
      qrCode,
      reference,
      url,
      isLoading,
      error,
      errorCode,
      status,
      userId,
      username,
    } = this.props;

    const verificationUrl = `https://www.motostream.app/redirect.html?userId=${userId || ""}`; // Prevent SSR crash

    const errorMessage =
      typeof error === "string"
        ? error
        : error?.message || error?.error || "An error occurred";

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.contentBox}>
            <div className={s.leftSection}>
              <h1 className={s.headerTitle}>
  <FormattedMessage {...messages.verificationTitle} />
</h1>
              <p className={s.verifySubTitle}>
  <FormattedMessage {...messages.verificationSubtitle} />
</p>

              <ol className={s.stepsList}>
                <li><FormattedMessage {...messages.verificationStep1} /></li>
                <li><FormattedMessage {...messages.verificationStep2} /></li>
                <li><FormattedMessage {...messages.verificationStep3} /></li>
              </ol>

              <div className={s.otherOptions}>
                <div className={s.otherOptionsTitle}>
  <FormattedMessage {...messages.verificationOtherWays} />
</div>
                <div className={s.otherOptionsLinks}>
                  <Link
                    to="#"
                    onClick={this.toggleEmailModal}
                    className={s.verifyLink}
                  >
                    {" "}
                    <FormattedMessage {...messages.verificationEmail} />
                  </Link>
                  <Link
                    to="#"
                    onClick={this.toggleNumberModal}
                    className={s.verifyLink}
                  >
                    {" "}
                    <FormattedMessage {...messages.verificationPhone} />
                  </Link>
                  <Link
                    to="#"
                    onClick={this.handleCopyLink}
                    className={s.verifyLink}
                  >
                    {" "}
                    {this.state.copied ? (
  <FormattedMessage {...messages.verificationCopied} />
) : (
  <FormattedMessage {...messages.verificationCopy} />
)}{" "}
                    <MdContentCopy className={s.icon} />
                    {/* <FaCheck className={s.icon} /> */}
                  </Link>
                  {/* <Link
                    to="#"
                    onClick={this.toggleLoaderModal}
                    className={s.verifyLink}
                  >
                    {" "}
                    Verification Loader {">"}
                  </Link>
                  <Link
                    to="#"
                    onClick={this.toggleFailedModal}
                    className={s.verifyLink}
                  >
                    {" "}
                    Verification Failed {">"}
                  </Link>
                  <Link
                    to="#"
                    onClick={this.toggleCodeSuccessModal}
                    className={s.verifyLink}
                  >
                    {" "}
                    Code Verification Success {">"}
                  </Link> */}
                </div>
              </div>
            </div>

            <div className={s.rightSection}>
              <div className={cx(s.qrTitle, { [s.expired]: isExpired })}>
                {isExpired ? (
  <FormattedMessage {...messages.verificationQrExpired} />
) : (
  <FormattedMessage {...messages.verificationQrTitle} />
)}
              </div>
              <div className={cx(s.qrSubtitle, { [s.expired]: isExpired })}>
                {isExpired ? (
  <FormattedMessage {...messages.verificationQrExpiredSubtitle} />
) : (
  <FormattedMessage {...messages.verificationQrSubtitle} />
)}
              </div>
              <div className={cx(s.qrContainer, { [s.expired]: isExpired })}>
                {isExpired ? (
                  <QRCode
                    value={verificationUrl}
                    size={256}
                    className={cx(s.qrCode, s.expired)}
                  />
                ) : (
                  <QRCode
                    value={verificationUrl}
                    size={256}
                    className={s.qrCode}
                  />
                )}
              </div>
              <div className={s.qrExpiryContainer}>
                {!isExpired && !isLoading && !error && (
                  <div className={s.qrExpiry}>
                    <img src={clockIcon} alt="clock" />
                    <FormattedMessage {...messages.verificationQrExpiresIn} />{" "}
                    <span className={s.highlight}>
                      {this.formatTime(timeLeft)}
                    </span>
                  </div>
                )}
                {isExpired && (
                  <button
                    className={s.refreshButton}
                    onClick={this.refreshQRCode}
                    disabled={isRefreshing}
                  >
                    {isRefreshing ? (
  <FormattedMessage {...messages.verificationGenerating} />
) : (
  <FormattedMessage {...messages.verificationRegenerateQr} />
)}
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className={s.skipSection}>
            <Link to="#" onClick={this.toggleSkipModal} className={s.skipLink}>
              <FormattedMessage {...messages.verificationSkip} />
            </Link>
          </div>
        </div>

        {/* {showEmailModal && (
          <EmailVerificationModal
            onClose={this.toggleEmailModal}
            verificationLink={qrData}
          />
        )} */}

        {/* Email Verification Modal */}
        <EmailVerificationModal
          onClose={this.toggleEmailModal}
          show={showEmailModal}
          url={verificationUrl}
        />

        {/* Number Verification Modal */}
        <NumberVerificationModal
          onClose={this.toggleNumberModal}
          show={showNumberModal}
          url={verificationUrl}

        />

        {/* Skip Verification Modal */}
        <SkipVerificationModal
          onClose={this.toggleSkipModal}
          show={showSkipModal}
        />

        {/* Verification Success Modal */}
        <VerificationSuccess
          onClose={this.handleSuccessClose}
          show={this.state.showSuccessModal}
        />

        {/* Verification Loader Modal */}
        <VerificationLoaderModal
          onClose={this.toggleLoaderModal}
          show={this.state.showLoaderModal}
        />

        {/* Verification Failed Modal */}
        <VerificationFailedModal
          onClose={this.handleFailedRetry}
          show={this.state.showFailedModal}
        />

        {/* Code Verification Success Modal (disabled to avoid duplicate modal) */}
        {/* <CodeVerificationSuccessModal
          onClose={this.handleSuccessClose}
          show={this.state.showSuccessModal}
        /> */}
      </div>
    );
  }
}

const mapState = (state) => {
  const accountData = state.account && state.account.data ? state.account.data : {};
  return {
    qrCode: state.qrcode.qrData,
    reference: state.qrcode.reference,
    url: state.qrcode.url,
    isLoading: state.qrcode.isLoading,
    error: state.qrcode.error,
    errorCode: state.qrcode.errorCode,
    status: state.qrcode.status,
    userId: accountData.userId || "",
    username: (accountData.firstName || "") + " " + (accountData.lastName || ""),
  };
};

const mapDispatch = {
  // generateQRCode,
  getDocumentVerifications,
 // getDocumentVerificationStatus,
};

export default connect(mapState, mapDispatch)(withStyles(s)(Verification));
